module.exports = __webpack_public_path__ + "img/USDC.1ae486d0b.svg";